function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import cn from 'classnames';
import map from 'lodash/map';
import intlShape from 'shapes/intlShape';
var _React_PureComponent;
class NavTabs extends (_React_PureComponent = React.PureComponent) {
    onClick(evt, value) {
        evt.preventDefault();
        this.props.onClick(value);
    }
    renderItem(item) {
        const { label, value } = item;
        const { activeItemValue } = this.props;
        return /*#__PURE__*/ _jsx("li", {
            className: "nav-item",
            children: /*#__PURE__*/ _jsx("a", {
                className: cn('nav-link', {
                    active: value === activeItemValue
                }),
                href: "",
                onClick: (evt)=>this.onClick(evt, value),
                children: this.props.intl.formatMessage(label)
            })
        }, value);
    }
    render() {
        return /*#__PURE__*/ _jsx("ul", {
            className: "nav nav-tabs",
            children: map(this.props.items, (item)=>this.renderItem(item))
        });
    }
}
_define_property(NavTabs, "propTypes", {
    // Explicit props
    items: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.object.isRequired,
        value: PropTypes.string.isRequired
    })),
    activeItemValue: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    // Implicit props
    intl: intlShape
});
export default injectIntl(NavTabs);
